// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"7b157d3b","318":"8ba345a6","342":"01a0b7c8","390":"8e8a9463","496":"e247b148","651":"96957685","714":"dbc60fdd"}[chunkId] + ".chunk.js";
};